import * as UtilBase from './curatedSeriesList-util-base'
export default { ...UtilBase }
